import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/static/logo.png'


const _hoisted_1 = { class: "topBar" }
const _hoisted_2 = { class: "openMenus" }
const _hoisted_3 = { class: "logo" }
const _hoisted_4 = { class: "panel" }
const _hoisted_5 = { class: "panel_left" }
const _hoisted_6 = { class: "panel_right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_setting = _resolveComponent("setting")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_document = _resolveComponent("document")!
  const _component_SwitchFilled = _resolveComponent("SwitchFilled")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_button, {
          type: "success",
          icon: _ctx.Expand,
          size: "large",
          circle: "",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (this.isCollapse = !this.isCollapse))
        }, null, 8, ["icon"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, { to: '/' }, {
          default: _withCtx(() => _cache[1] || (_cache[1] = [
            _createElementVNode("img", { src: _imports_0 }, null, -1)
          ])),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_el_menu, {
          "default-active": "1",
          class: "el-menu-vertical-demo",
          collapse: _ctx.isCollapse,
          onOpen: _ctx.handleOpen,
          onClose: _ctx.handleClose
        }, {
          default: _withCtx(() => [
            (_ctx.status == 2 || _ctx.status == 1)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  to: '/admin/aabb/audit'
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_menu_item, { index: "1" }, {
                      title: _withCtx(() => _cache[2] || (_cache[2] = [
                        _createTextVNode("审核管理")
                      ])),
                      default: _withCtx(() => [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_setting)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.status == 1)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 1,
                  to: '/admin/aabb/personnel'
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_menu_item, { index: "2" }, {
                      title: _withCtx(() => _cache[3] || (_cache[3] = [
                        _createTextVNode(" 人员管理 ")
                      ])),
                      default: _withCtx(() => [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_document)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.status == 2 || _ctx.status == 1)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 2,
                  to: '/admin/aabb/apply'
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_menu_item, { index: "3" }, {
                      title: _withCtx(() => _cache[4] || (_cache[4] = [
                        _createTextVNode(" 创作管理 ")
                      ])),
                      default: _withCtx(() => [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_SwitchFilled)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["collapse", "onOpen", "onClose"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_el_scrollbar, null, {
          default: _withCtx(() => [
            _createVNode(_component_router_view, { class: "rv" })
          ]),
          _: 1
        })
      ])
    ])
  ], 64))
}